import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('listbox');

export { TAG_NAME };
